import './App.css';
import Router from './Routes/Router';
import Menu from './components/Menu/Menu';
import { BrowserRouter } from 'react-router-dom';
import 'keen-slider/keen-slider.min.css'

function App() {
  return (
   
     <BrowserRouter>
      <Router/>
        <Menu />
      </BrowserRouter>
   

  );
}

export default App;

